import EditIcon from '@mui/icons-material/Edit'
import { IconButton } from '@mui/material'
import { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
import { IOrg } from '../../../data/Org'
import { IPerson } from "../../../data/Person"
import FormDialog from '../../../utils/FormDialog'
import { useAppDispatch } from '../AdminReduxHooks'
import { AdminRootState } from '../AdminStore'
import { ICommonEditEntityButtonProps } from '../common/CommonProps'
import { updateOrganizationAsync } from '../common/FetchApi'
import EditForm from './EditForm'

export interface IEditEntityButtonProps extends ICommonEditEntityButtonProps<IOrg> {}


export default function EditEntityButton(props: IEditEntityButtonProps) {
    const [showDialog, setShowDialog] = useState(false)
    const [editData, setEditData] = useState({...props.item})
    const dispatch = useAppDispatch()
    
    const orgDoctors = useSelector<AdminRootState>( (state) => 
        state.doctors.all.filter(x => x.isActive && x.partitionKey === props.item.rowKey) )
    
    const orgTechs = useSelector<AdminRootState>( (state) => 
        state.techs.all.filter(x => x.isActive && x.partitionKey === props.item.rowKey) )

    const onFieldUpdate = (id: string, value: string | boolean ) => {
        const updatedData = {...editData}
        // @ts-ignore: TS7053 // It's ok to index an object by key, but typescript doesn't like it when the object properties of different types
        updatedData[id as keyof IOrg] = value
        setEditData(updatedData)
      }


    const onDialogFinished = async (isOk: boolean) => {
        if (isOk) {
            const isLabelPresent = props.items.findIndex(x => (x.label === editData.label) && (x.rowKey !== editData.rowKey)) !== -1
            if (isLabelPresent) {
                return `Error: The label ${editData.label} is already present in the list.`
            }

            const ret = await updateOrganizationAsync(editData)            
            if (ret !== '') {
                return 'API Error:' + ret
            }

            dispatch(props.updateAction(editData))
            setShowDialog(false)
            return ''
        } else {
            setShowDialog(false)
            return ''
        }
    }

    const dialogTitle = props.item.partitionKey === 'lab' 
        ? 'Edit Lab'
        : 'Edit Hospital'

    const type = props.item.partitionKey
    return (
        <Fragment>
            <IconButton sx={{mt:'-5px'}} onClick={() =>setShowDialog(true)} >
                <EditIcon width={props.width} fontSize='small'/>
            </IconButton>
            <FormDialog show={showDialog} title={dialogTitle} closeCallback={onDialogFinished} 
                    form={<EditForm data={editData} type={type} onDataItemChanged={onFieldUpdate} 
                        contactSource={(type === 'lab' ? orgTechs : orgDoctors) as Array<IPerson>}/>} /> 
        </Fragment>
    )    
}

